// Clean text by removing punctuation and normalizing whitespace
export const cleanText = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  return text
    .replace(/[.,;:!?\-()[\]{}"""'']/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

// Check if transcript matches any phrases (exact or variations)
export const findMatches = (transcript, items, variationsCache) => {
  const matches = new Set();
  const cleanedTranscript = cleanText(transcript.toLowerCase());
  
  items.forEach((item, index) => {
    const cleanedItem = cleanText(item.toLowerCase());
    
    // Direct exact match
    if (cleanedTranscript.includes(cleanedItem)) {
      matches.add(index);
      return;
    }
    
    // Check variations from cache
    const variations = variationsCache[item] || [];
    for (const variant of variations) {
      const cleanedVariant = cleanText(variant.toLowerCase());
      if (cleanedTranscript.includes(cleanedVariant)) {
        matches.add(index);
        return;
      }
    }
  });
  
  return matches;
};

// Initialize speech recognition
export const initSpeechRecognition = (onResult, onError) => {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  
  if (!SpeechRecognition) {
    return null;
  }
  
  const recognition = new SpeechRecognition();
  recognition.continuous = true;
  recognition.interimResults = false;
  recognition.lang = 'en-US';
  
  recognition.onresult = (event) => {
    for (let i = event.resultIndex; i < event.results.length; i++) {
      if (event.results[i].isFinal) {
        const transcript = event.results[i][0].transcript;
        onResult(transcript);
      }
    }
  };
  
  recognition.onerror = (event) => {
    onError(event.error);
  };
  
  recognition.onend = () => {
    // Will be handled by component
  };
  
  return recognition;
};